import { render, staticRenderFns } from "./CreateUnavailability.vue?vue&type=template&id=00c0baaf&"
import script from "./CreateUnavailability.vue?vue&type=script&lang=js&"
export * from "./CreateUnavailability.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/cjzhi98/chatwoot-saas/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('00c0baaf')) {
      api.createRecord('00c0baaf', component.options)
    } else {
      api.reload('00c0baaf', component.options)
    }
    module.hot.accept("./CreateUnavailability.vue?vue&type=template&id=00c0baaf&", function () {
      api.rerender('00c0baaf', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/routes/dashboard/organization/staffs/CreateUnavailability.vue"
export default component.exports